import React from "react"
import { useTranslation } from "react-i18next"

import { Checkbox } from "components"
import classes from "./OfsIsDispatched.module.scss"

const OfsIsDispatched = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleIsViewed = (checked) => {
    setForm(prev => ({
      ...prev, isDispatched: checked ? true : null
    }))
  }

  return (
    <div className={classes["checkbox-container"]}>
      <div className={classes["checkbox"]}>
        {t("از_انبار_خارج_شده")}
      </div>

      <Checkbox
        checked={form.isDispatched}
        onChange={handleIsViewed}
      />
    </div>
  )
}

export default OfsIsDispatched